// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".OzzXkrdOmDuARJ-ETCCHoA\\=\\= {\n  font-size: 14px;\n}\n\n._9t9v6\\+bQiXQ7VnCUM-UIrg\\=\\= {\n  padding: 4px 0px;\n  width: 100%;\n  overflow-wrap: anywhere;\n}\n", "",{"version":3,"sources":["webpack://./src/content/styles/WithCaption.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,uBAAuB;AACzB","sourcesContent":[".captionComponentContainer {\n  font-size: 14px;\n}\n\n.captionTextContainer {\n  padding: 4px 0px;\n  width: 100%;\n  overflow-wrap: anywhere;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"captionComponentContainer": "OzzXkrdOmDuARJ-ETCCHoA==",
	"captionTextContainer": "_9t9v6+bQiXQ7VnCUM-UIrg=="
};
export default ___CSS_LOADER_EXPORT___;
